module.exports = __webpack_public_path__ + "images/kaitori_bonus_lp/mainvisual-title-sp@2x_1337938a0465f6c76ef593a69eb423f1.png";